(() => {
  const init = (section) => {
    if (section.dataset.ciInvisibleReady === "true") return;
    section.dataset.ciInvisibleReady = "true";

    const tabs = [...section.querySelectorAll("[data-finish-tab]")];
    const panels = [...section.querySelectorAll("[data-finish-panel]")];
    const result = section.querySelector("[data-finish-result]");

    const activate = (handle, moveFocus = false) => {
      const activeTab = tabs.find((tab) => tab.dataset.finishTab === handle);
      if (!activeTab) return;

      section.dataset.active = handle;
      tabs.forEach((tab) => {
        const selected = tab === activeTab;
        tab.setAttribute("aria-selected", selected ? "true" : "false");
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.finishPanel !== handle;
      });

      if (result) result.textContent = activeTab.dataset.result || "";
      if (moveFocus) activeTab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activate(tab.dataset.finishTab));
      tab.addEventListener("keydown", (event) => {
        if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = tabs.length - 1;
        if (event.key === "ArrowRight" || event.key === "ArrowDown") nextIndex = (index + 1) % tabs.length;
        if (event.key === "ArrowLeft" || event.key === "ArrowUp") nextIndex = (index - 1 + tabs.length) % tabs.length;
        activate(tabs[nextIndex].dataset.finishTab, true);
      });
    });

    section.querySelectorAll("[data-purchase-scroll]").forEach((button) => {
      button.addEventListener("click", () => {
        const purchaseArea = document.querySelector(
          ".product__info-container, .product__info-wrapper, product-form, form[action*='/cart/add']"
        );
        purchaseArea?.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          section.classList.add("is-visible");
          observer.disconnect();
        },
        { threshold: 0.18 }
      );
      observer.observe(section);
    } else {
      section.classList.add("is-visible");
    }

    activate(section.dataset.active);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-ci-invisible]").forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
